import styled from 'styled-components'
import theme, {colors} from '../../../styles/theme'

export const SidenavBox = styled.div`
  background-color: #fff;
  min-height: calc(100vh - 96px);
  box-sizing: border-box;
  width: 100%;
  max-width: 250px;
  padding-top: 24px;
  display: flex;
  flex-flow: column;
  gap: 16px;
  border-right: 1px solid #ebeffc;
  position: fixed;

  @media only screen and (max-width: 1015px) {
    max-width: 200px;
  }

  ${theme.breakpoints.down('md')} {
    min-height: calc(100vh - 56px);
    max-width: 250px;
  }

  ${theme.breakpoints.down('sm')} {
    max-width: 100%;
  }
`

export const Item = styled.div<{$isSubItem?: boolean}>`
  cursor: pointer;
  display: flex;
  width: 100%;
  box-sizing: border-box;
  gap: 8px;
  height: 32px;
  align-items: center;
  color: ${colors.bksGray80};

  ${({$isSubItem}) =>
    $isSubItem
      ? `
        padding-left: 48px;
      `
      : `padding-left: 24px;`}

  @media only screen and (max-width: 1015px) {
    ${({$isSubItem}) =>
      $isSubItem
        ? `
          padding-left: 32px;
        `
        : `padding-left: 24px;`}
  }

  ${theme.breakpoints.down('md')} {
    ${({$isSubItem}) =>
      $isSubItem
        ? `
          padding-left: 48px;
        `
        : `padding-left: 24px;`}
  }

  && span {
    font-size: 20px;
    font-weight: bold;
  }

  && .itemIcon {
    width: 16px;
    height: 16px;
  }

  &:hover {
    background-color: #e8f3fd;
    font-weight: bold;
  }
`

export const SubItems = styled.div<{$isExpanded?: boolean; height?: number}>`
  display: flex;
  flex-flow: column;
  gap: 8px;
  overflow: hidden;

  ${({$isExpanded, height}) =>
    $isExpanded
      ? `
      height: ${height}px;
    `
      : `
      height: 0;
      margin-bottom: -16px;
    `}
  transition: height 0.3s ease;
`
